export default __webpack_public_path__ + "static/media/chess.60292781.png";